export const vFactsConstants = {


    GETALL_REQUEST: 'vFacts_GETALL_REQUEST',
    GETALL_SUCCESS: 'vFacts_GETALL_SUCCESS',
    GETALL_FAILURE: 'vFacts_GETALL_FAILURE'
};
